(function(angular){
	'use strict';
	
	angular.module('affixModule', [
		'BaseConfig'
	]);

})(window.angular);